import React, { useEffect } from "react";
import { Box, Fade, Slide, IconButton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { set } from "../../store/globalSlice";
import Login from "../Login";
import { CrossIcon } from "../../assets/icons";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function LoginModal() {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const dispatch = useDispatch();
  const showLoginModal = useSelector((state: RootState) => state.global.showLoginModal);

  const handleClose = () => {
    dispatch(set({ showLoginModal: false }));
  };

  const location = useLocation();

  useEffect(() => {
    if (showLoginModal) {
      handleClose();
    }
  }, [location.pathname]);

  return (
    <>
      <Fade in={showLoginModal}>
        <Box
          className="login-modal-backdrop"
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={handleClose}
        />
      </Fade>
      <Slide direction="up" in={showLoginModal} mountOnEnter unmountOnExit>
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none", // Allow clicks to pass through to backdrop
          }}
        >
          <Box
            sx={{
              maxWidth: "420px",
              width: "90%",
              maxHeight: "90vh",
              overflow: "auto",
              borderRadius: "16px",
              boxShadow: "0px 12px 32px 0px rgba(0, 0, 0, 0.15)",
              backgroundColor: "var(--body-bg)",
              position: "relative",
              pointerEvents: "auto", // Re-enable pointer events for the modal content
              "@media (max-width: 600px)": {
                width: "95%",
                maxWidth: "none",
              },
            }}
          >
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: 8,
                ...(isRTL ? { left: 8 } : { right: 8 }),
                zIndex: 1,
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 1)",
                },
              }}
            >
              <CrossIcon />
            </IconButton>
            <Login />
          </Box>
        </Box>
      </Slide>
    </>
  );
}
